class Appeared {
	constructor() {

		const items = document.querySelectorAll("[data-appear]");

		items.forEach(elem => {

			ScrollTrigger.create({
				trigger: elem,
				start: "top 100%",
				end: "bottom 0%",
				onEnter: () => {
					elem.classList.add('appeared');
				}
			});

		});
	}
}
